// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__ONsR9","name":"styles_name__35Bw6","phone":"styles_phone__3BElv"};